import React, { useState } from "react"
import {
  Button,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap"

import labels from "./const"
import useLabels from "../../utils/useLabels"
import * as s from "./style.module.css"

export default function TimetableTabs({ lang }) {
  const t = useLabels(labels, lang)
  const [activeTab, setActiveTab] = useState("1")

  return (
    <div id="harmonogram" className={s.timetableTabs}>
      <Container>
        <div className={s.header}>
          <h2
            className={s.globalTitle}
            dangerouslySetInnerHTML={{ __html: t.title }}
          />
          <img
            className={s.line}
            src={require("../Text/icons/line.svg").default}
          />
          <p
            className={s.titleDesc}
            dangerouslySetInnerHTML={{ __html: t.subtitle }}
          />
          <p
            className={s.signUp}
          >Zapisz się:</p>
          <div className="d-flex flex-column align-content-center">
            <div className="mb-4">
              <a href="https://app.evenea.pl/event/hack4change2027/" target="_blank">
                <Button
                  color="primary"
                  dangerouslySetInnerHTML={{
                    __html: t.button
                  }}
                />
              </a>
            </div>
            {/* <div>
              <a href="https://app.evenea.pl/event/hack4change2023webinaria/" target="_blank">
                <Button
                  color="primary"
                  dangerouslySetInnerHTML={{
                    __html: t.button2
                  }}
                />
              </a>
            </div> */}
          </div>
        </div>
        <div className={s.tabs}>
          <Nav className={s.tabButtonsWrapper} tabs>
            {t.tabs.map(tab => (
              <NavItem>
                <NavLink
                  className={activeTab == tab.id ? "active" : ""}
                  onClick={() => setActiveTab(tab.id)}
                >
                  <p className={s.dateDay}>{tab.day}</p>
                  <p className={s.dateDetails}>{tab.dateDetails}</p>
                </NavLink>
              </NavItem>
            ))}
          </Nav>

          <TabContent activeTab={activeTab}>
            {t.tabs.map(tab => (
              <TabPane tabId={tab.id}>
                {tab.tabHours.map(({ hours, text }) => (
                  <div className={s.singleHoursWrapper}>
                    <p
                      className={s.hours}
                      dangerouslySetInnerHTML={{ __html: hours }}
                    />
                    <p
                      className={s.hoursDesc}
                      dangerouslySetInnerHTML={{ __html: text }}
                    />
                  </div>
                ))}
              </TabPane>
            ))}
          </TabContent>
        </div>
      </Container>
      <img className={s.splash} src={require("./images/splash.svg").default} />
    </div>
  )
}
